import cn from 'classnames';
import React, { PropsWithChildren } from 'react';
import './DSInputStyles.scss';
import { DSRadio, DSRadioColor } from './DSRadio';

export type DSRadioGroupOption<T> = {
	key: T;
	value: string;
	disabled?: boolean;
};

type DSRadioGroupProps<T> = Pick<React.HTMLAttributes<HTMLDivElement>, 'className'> & {
	color?: DSRadioColor;
	options: Array<DSRadioGroupOption<T>>;
	value?: T;
	onChange: (value: T) => void;
	horizontal?: boolean;
};

export const DSRadioGroup = <T extends React.Key | boolean>({ color = 'theme', ...props }: PropsWithChildren<DSRadioGroupProps<T>>) => {
	const iterationKey = (option: DSRadioGroupOption<T>): React.Key => {
		if (typeof option.key == 'boolean') {
			return option.key + '';
		}

		return option.key;
	};

	const classes = () => cn('flex', props.horizontal ? 'flex-row gap-6' : 'flex-col gap-4', props.className);

	return (
		<div className={classes()}>
			{props.options.map((option) => (
				<div key={iterationKey(option)}>
					<DSRadio
						color={color}
						enabled={props.value === option.key}
						onEnabled={() => props.onChange(option.key)}
						disabled={option.disabled}
						label={option.value}
					/>
				</div>
			))}
		</div>
	);
};
